// extracted by mini-css-extract-plugin
export var emailBlockLink = "_n1-0";